module.exports = __webpack_public_path__ + "static/media/1.60222f99.png";